<template>
    <section class="writings-list">
        <el-row v-for="writing in writings" :key="writing._id" class="writing-row">
            <el-col :span="18" :push="3" >
                <article class="writing">
                    <header>
                        <h3>{{writing.title}}</h3>
                        <section class="author">
                            <span>نویسنده: </span>
                            <span>{{writing.creator.firstName}} </span>
                            <span>{{writing.creator.lastName}}</span>
                        </section>
                    </header>
                    <section class="writing-body">
                        <p>{{writing.abstract}}</p>
                        <section>
                            <el-button type="warning" size="small" class="writing-button edit-button">
                                <i class="el-icon-edit"></i>
                                ویرایش مطلب
                            </el-button>
                            <el-button type="danger" size="small" class="writing-button delete-button" @click="openDeleteDialog(writing._id)">
                                حذف مطلب
                                <i class="el-icon-delete"></i>
                            </el-button>
                        </section>

                    </section>
                    <footer>
                    <span>
                        نوشته شده در تاریخ:
                        {{dateConverter(writing.createdAt)}}
                    </span>
                    </footer>
                </article>
            </el-col>
        </el-row>

        <el-dialog
            class="delete-dialog"
            title="آیا مطمئن هستید؟"
            :visible.sync="writingDeleteDialogVisible"
            width="30%"
            center>
            <template>با حذف شدن مطلب تمام داده‌های مربوط به آن نیز حذف می‌شوند و امکان بازیابی وجود ندارد!</template>
            <template slot="footer" >
                <el-button @click="writingDeleteDialogVisible = false">خیر</el-button>
                <el-button type="danger" @click="deleteWriting()">بله، حذف شود</el-button>
            </template>
        </el-dialog>
    </section>
</template>

<script>
    /* eslint-disable */
    import jMoment from 'jalali-moment';
    export default {
        name: 'UserWritings',
        data() {
            return {
                writings: [],
                page: 1,
                limit: 20,
                deletingWritingId: '',
                writingDeleteDialogVisible: false
            }
        },
        created() {
            this.getWritings(1, 20);
        },
        methods: {
            getWritings(page, limit) {
                this.$http.get(`${this.apiURL}/writing/by-user?page=${page}&limit=${limit}`).then((response) => {
                    console.log(response);
                    this.writings = response.data.writings;
                    this.page = response.data.page;
                }).catch((error) => {
                    console.error(error.response.data);
                });
            },
            dateConverter(date) {
                let jYear = jMoment(date).format('jYYYY');
                let jMonth = jMoment(date).locale('fa').format('jMMMM');
                let jDay = jMoment(date).locale('fa').format('jDD');
                let jDaysOfWeek = jMoment(date).locale('fa').localeData().weekdays();
                jDaysOfWeek.unshift(jDaysOfWeek.pop());
                let jDayOfWeek = jDaysOfWeek[jMoment(date).locale('fa').weekday()];
                return `${jDayOfWeek} ${jDay} ${jMonth} ${jYear}`;
            },
            deleteWriting() {
                this.writingDeleteDialogVisible = false;
                this.$http.delete(`${this.apiURL}/writing/${this.deletingWritingId}`).then(
                    (response) => {
                        this.$msgbox('با موفقیت حذف شد.');
                        this.writings = this.writings.filter( (v, i) => (v._id !== this.deletingWritingId) );
                    }
                ).catch(
                    (error) => {
                        console.error(error.response.data);
                        this.$alert('حذف انجام نشد!');
                    }
                );
            },
            openDeleteDialog(id) {
                this.deletingWritingId = id;
                this.writingDeleteDialogVisible = true;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .writings-list {
        width: 100%;

        .writing-row {
            direction: rtl;
            text-align: right;
            margin: 0 0 20px 0;

            .writing {
                padding: 10px 20px;
                background-color: #E8F3EC;
                box-shadow: 0 0 8px 0 rgba(0, 0, 0, .08), 0 0 2px 0 rgba(0, 0, 0, .08);

                header {
                    color: #8b8b8b;
                    margin-bottom: 20px;

                    h3 {
                        margin: 0;
                        color: #4886FF;
                    }
                    .author {
                        font-size: 14px;
                    }
                }

                .writing-body {

                    section {
                        text-align: left;
                        margin: 10px 0;

                        .writing-button::v-deep {
                            font-weight: bold;

                            i {
                                font-weight: bold;
                            }

                            &.edit-button {
                                margin-left: 20px;
                            }

                            &.delete-button {
                                margin-left: 0;
                            }
                        }
                    }

                }

                footer {
                    padding: 5px;
                    border-top: 1px solid #BBBBBB;
                    font-size: 12px;
                    color: #8b8b8b;
                }
            }
        }

        .delete-dialog::v-deep {
            .el-dialog {
                min-width: 350px;
                max-width: 450px;

                @media only screen and (max-width: 767px) {
                    min-width: unset;
                    width: 80%;
                }

                .el-dialog__body {
                    word-break: normal;
                    text-align: justify;
                }

                .el-dialog__footer {
                    display: flex;
                    justify-content: space-between;
                }
            }
        }
    }

</style>
